export const sortByString = (a: string, b: string) => a.localeCompare(b, 'en');

/** null/undefined 값의 정렬 위치 전략 */
export type NullPlacement = 'last' | 'first' | 'by-direction';

/** 정렬 방향 (대소문자 무관) */
export type SortDirection = 'ASC' | 'DESC' | 'asc' | 'desc';

export interface CompareOptions {
  /**
   * null/undefined 값의 정렬 위치
   * - 'last': 항상 뒤로 (기본값)
   * - 'first': 항상 앞으로
   * - 'by-direction': ASC면 앞, DESC면 뒤 (null을 최솟값으로 취급)
   */
  nulls?: NullPlacement;
}

/**
 * 두 값을 비교하여 정렬 순서를 반환하는 범용 비교 함수.
 * number, string, null/undefined를 처리하며 null 배치 전략을 설정할 수 있다.
 */
export const compareValues = (
  aVal: number | string | null | undefined,
  bVal: number | string | null | undefined,
  direction: SortDirection,
  options?: CompareOptions,
): number => {
  const nulls = options?.nulls ?? 'last';
  const isAsc = direction.toUpperCase() === 'ASC';

  const aIsNull = aVal == null;
  const bIsNull = bVal == null;

  if (aIsNull && bIsNull) return 0;

  if (aIsNull || bIsNull) {
    switch (nulls) {
      case 'last':
        return aIsNull ? 1 : -1;
      case 'first':
        return aIsNull ? -1 : 1;
      case 'by-direction':
        return aIsNull ? (isAsc ? -1 : 1) : isAsc ? 1 : -1;
    }
  }

  if (typeof aVal === 'string' && typeof bVal === 'string') {
    return isAsc ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
  }

  if (typeof aVal === 'number' && typeof bVal === 'number') {
    return isAsc ? aVal - bVal : bVal - aVal;
  }

  return 0;
};
